import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { showCancelCNInvtiationModal } from 'actions/modal';
import { cancelCNInvitationTicket } from 'actions/waitingArea';
import { displayGlobalMessage } from 'actions/globalMessage';
// TODO-HH - Remove it once pubnub update ready

const CenterPanel = (props) => {
  const dispatch = useDispatch();

  let [canceling, setCanceling] = useState(false);
  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white mrlnull mrbnull mrtm mrrl';
  let withoutIcon = 'ui button left-text color-button color-button-hover color-white mrlnull mrbnull mrtm';

  const cancelInvitation = () => {
    let payload = {
      authTicketId: props.selectedConsultNowCaller.authTicketId,
    };
    let cb = (result, err) => {
      if (result) {
        setCanceling(false);
        dispatch(showCancelCNInvtiationModal(false));
        dispatch(
          displayGlobalMessage({
            text: APP.LANGUAGE.CancelConsultNowInvitation.SuccessMessage,
            visible: true,
            messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
            autoHide: true,
          })
        );
      }
      // // TODO-HH - Custom error handling if required
      // dispatch(getUserBasicProfile());
      setCanceling(false);
    };
    setCanceling(true);
    dispatch(cancelCNInvitationTicket(payload, cb));
  };

  return (
    <div className="ui form mrbl pdtsss">
      <div className="title-sms">{APP.LANGUAGE.CancelConsultNowInvitation.Content}</div>
      <button
        tabIndex="1"
        type="button"
        className={canceling ? withoutIcon + ' loading' : withoutIcon + ' no-icon-btn'}
        onClick={cancelInvitation}
      >
        {APP.LANGUAGE.CancelConsultNowInvitation.YesButton}
      </button>
      <button
        tabIndex="2"
        type="button"
        className="ui button color-bad-things color-bad-things-hover color-white mrlnull mrbnull mrtm"
        onClick={() => dispatch(showCancelCNInvtiationModal(false))}
      >
        {APP.LANGUAGE.No}
      </button>
    </div>
  );
};

export default CenterPanel;
